import { Box, List, ListItem, ListProps, Stack } from '@mui/material';
import React from 'react';
import { FormattedDate } from 'react-intl';
import { MessagesTags } from '../MessagesPage';
import { LineClamp } from '../common';
import { Message } from '../types/messages';

interface MessagesListProps {
  messages: Message[];
  onClick?: (messageId: Message['id']) => void;
  slotProps?: {
    listProps?: Partial<ListProps>;
  };
}

export const MessagesList = ({ messages, onClick, slotProps: { listProps } = {} }: MessagesListProps) => (
  <List sx={{ width: 1, bgcolor: 'background.paper', ...listProps?.sx }} {...listProps}>
    {messages.map((message, idx) => {
      const { id: messageId, title } = message;
      return (
        <React.Fragment key={messageId}>
          <ListItem
            sx={{
              paddingX: 1
            }}
          >
            <Stack spacing={1}>
              <Stack spacing={1} justifyContent="center">
                <Stack direction="row" spacing={2} alignItems="center">
                  <Box color="text.secondary" typography="body2">
                    <FormattedDate value={message.createdDate} month="short" day="numeric" year="numeric" />
                  </Box>
                  <MessagesTags message={message} />
                </Stack>
                <LineClamp maxLines={1} sx={{ fontWeight: 'bold' }}>
                  {title}
                </LineClamp>
              </Stack>
            </Stack>
          </ListItem>
        </React.Fragment>
      );
    })}
  </List>
);
